import React from "react";
import FormSection from "../FormSection";

import Actions from "./Actions";
import { useEditServiceContext } from "components/ratecard/contextProviders";
import { Spin } from "antd";

interface Props {
  title: string;
  loading?: boolean;
  saving?: boolean;
  isEditDisabled?: boolean;
  onSave?: () => void;
  onCancel?: () => void;
}

/**
 * Component to render main section of the
 * service rate card
 * @param props
 */
const ServiceFormWrapper: React.FC<Props> = ({
  children,
  title,
  loading = false,
  saving = false,
  isEditDisabled = false,
  onSave,
  onCancel,
}) => {
  const { allowEditing, setAllowEditing } = useEditServiceContext();

  const handleFormSubmit = () => {
    if (onSave) {
      onSave();
    }
  };

  const handleCancel = () => {
    setAllowEditing(false);

    if (onCancel) {
      onCancel();
    }
  };

  return (
    <FormSection
      title={title}
      extra={
        <Actions
          onCancel={handleCancel}
          onEdit={() => setAllowEditing(true)}
          onSave={handleFormSubmit}
          isEditMode={allowEditing}
          isSaving={saving}
          isEditDisabled={isEditDisabled || loading}
        />
      }
    >
      <Spin spinning={loading}>{children}</Spin>
    </FormSection>
  );
};

export default ServiceFormWrapper;
